function retrieve(localStorageKey: string): any {
  try {
    const dataStr = localStorage.getItem(localStorageKey);
    return dataStr || null;
  } catch (e) {
    return null;
  }
}

function save(localStorageKey: string, data: string) {
  localStorage.setItem(localStorageKey, data);
}

function cleanKey(localStorageKey: string): void {
  localStorage.removeItem(localStorageKey);
}

function retrieveJSON(localStorageKey: string): any {
  const dataStr = localStorage.getItem(localStorageKey);
  if (!dataStr) { return null; }
  try {
    const dataJson = JSON.parse(dataStr);
    return dataJson || null;
  } catch (e) {
    return null;
  }
}

function saveJSON(localStorageKey: string, data: any) {
  localStorage.setItem(localStorageKey, JSON.stringify(data));
}

function clean(): void {
  localStorage.clear();
}

export const localStorageKeeperService = {
  retrieve,
  save,
  clean,
  retrieveJSON,
  saveJSON,
  cleanKey,
};
